import { CALL_API, Schemas } from '../../common/middleware/api';

export const VOUCHERS_REQUEST = 'VOUCHERS_REQUEST';
export const VOUCHERS_SUCCESS = 'VOUCHERS_SUCCESS';
export const VOUCHERS_FAILURE = 'VOUCHERS_FAILURE';

export const VOUCHER_FETCH_REQUEST = 'VOUCHER_GET_REQUEST';
export const VOUCHER_FETCH_SUCCESS = 'VOUCHER_GET_SUCCESS';
export const VOUCHER_FETCH_FAILURE = 'VOUCHER_GET_FAILURE';

export const VOUCHER_UPDATE_REQUEST = 'VOUCHER_UPDATE_REQUEST';
export const VOUCHER_UPDATE_SUCCESS = 'VOUCHER_UPDATE_SUCCESS';
export const VOUCHER_UPDATE_FAILURE = 'VOUCHER_UPDATE_FAILURE';

export const loadVouchers = (options) => ({
	[CALL_API]: {
		types: [VOUCHERS_REQUEST, VOUCHERS_SUCCESS, VOUCHERS_FAILURE],
		endpoint: 'api/vouchers',
		request: options,
		schema: Schemas.VOUCHER_ARRAY
	}
});

export const fetchVoucher = (id) => ({
	[CALL_API]: {
		types: [VOUCHER_FETCH_REQUEST, VOUCHER_FETCH_SUCCESS, VOUCHER_FETCH_FAILURE],
		endpoint: `api/vouchers/${id}`,
		schema: Schemas.VOUCHER
	}
});

export const updateVoucher = (id, voucher) => ({
	[CALL_API]: {
		types: [VOUCHER_UPDATE_REQUEST, VOUCHER_UPDATE_SUCCESS, VOUCHER_UPDATE_FAILURE],
		endpoint: `api/vouchers/${id}`,
		method: 'PUT',
		request: voucher,
		schema: Schemas.VOUCHER,
		form: 'voucher'
	}
});